import { Arr_SEFPages } from "../../../../../arrays/SEF/Arr_SEFPages";
import { Update_To_MongoDB_By_ID_No_Alert } from "../../../../api/Update_To_MongoDB_By_ID_No_Alert";
import { Update_To_MongoDB_Push_To_Array_By_ID } from "../../../../api/Update_To_MongoDB_Push_To_Array_By_ID";
import { Find_Next_Awaiting_SEF } from "../api/Find_Next_Awaiting_SEF";
import { Send_SEF_Confirmation_Email_Update } from "../api/Send_SEF_Confirmation_Email_Update";

function SEFMassStage({ Attendee, setAttendee, id, logout }) {
  function handleUpdateAllSEFPageProgress(e, Value) {
    e.preventDefault();
    const newAttendee = { ...Attendee };
    newAttendee.SEFProgress = {
      ...Arr_SEFPages.reduce((acc, Obj_SEFPage) => {
        acc[Obj_SEFPage.Prop] = Value;
        return acc;
      }, {}),
    };
    newAttendee.SEFInfo = { ...newAttendee.SEFInfo, SEF: Value };
    setAttendee(newAttendee);

    Update_To_MongoDB_By_ID_No_Alert(
      {
        SEFProgress: newAttendee.SEFProgress,
        "SEFInfo.SEF": Value,
      },
      "Registers_2025",
      "All",
      id,
      logout
    );
    let newDoc = {
      DateTime: new Date().toISOString(),
      Note: "SEF Marked as " + Value,
      Staff_ID: localStorage.getItem("_id"),
    };
    Update_To_MongoDB_Push_To_Array_By_ID(
      "Registers_2025",
      "All",
      newDoc,
      "Notes",
      id,
      logout
    );
  }

  function handleUpdateAllSEFPageProgressEmail(e, Value) {
    e.preventDefault();
    const newAttendee = { ...Attendee };
    newAttendee.SEFProgress = {
      ...Arr_SEFPages.reduce((acc, Obj_SEFPage) => {
        acc[Obj_SEFPage.Prop] = Value;
        return acc;
      }, {}),
    };
    newAttendee.SEFInfo = { ...newAttendee.SEFInfo, SEF: Value };
    setAttendee(newAttendee);

    Update_To_MongoDB_By_ID_No_Alert(
      {
        SEFProgress: newAttendee.SEFProgress,
        "SEFInfo.SEF": Value,
      },
      "Registers_2025",
      "All",
      id,
      logout
    );
    let newDoc = {
      DateTime: new Date().toISOString(),
      Note: "SEF Marked as Complete and Emailed",
      Staff_ID: localStorage.getItem("_id"),
    };
    Update_To_MongoDB_Push_To_Array_By_ID(
      "Registers_2025",
      "All",
      newDoc,
      "Notes",
      id,
      logout
    );

    //Create a new variable called Obj_SEFInfo that contains the SEFInfo of the Attendee. This is by only keeping the objects that exist in Arr_SEFPages.MongoDB
    let Obj_SEFInfo = Arr_SEFPages.reduce((acc, Obj_SEFPage) => {
      acc[Obj_SEFPage.MongoDB] = Attendee[Obj_SEFPage.MongoDB];
      return acc;
    }, {});
    //remove Photos from the Obj_SEFInfo
    delete Obj_SEFInfo.Photos;
    delete Obj_SEFInfo.Contacts;

    Send_SEF_Confirmation_Email_Update(
      { Attendee: Attendee, Obj_SEFInfo: Obj_SEFInfo },
      logout
    );
  }

  function handleGoToNext(e) {
    e.preventDefault();
    Find_Next_Awaiting_SEF(logout);
  }

  return (
    <>
      <h1 style={{ marginBottom: "0px" }}>
        {Attendee.SEFInfo?.SEF ? Attendee.SEFInfo?.SEF : "..."}
      </h1>
      <h3 style={{ marginTop: "0px" }}>
        Submitted:{" "}
        {Attendee.SEFInfo?.SEFSubmissionDate
          ? Attendee.SEFInfo?.SEFSubmissionDate.replaceAll("T", " ").replaceAll(
              "Z",
              " "
            )
          : "..."}
      </h3>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <button
            style={{ width: "33%", backgroundColor: "#D11212" }}
            onClick={(e) => handleUpdateAllSEFPageProgress(e, "Incomplete")}
          >
            Incomplete
          </button>
          <button
            style={{ width: "33%", backgroundColor: "#0853B6" }}
            onClick={(e) => handleUpdateAllSEFPageProgress(e, "In_Progress")}
          >
            In Progress
          </button>
          <button
            style={{ width: "33%", backgroundColor: "#F98007" }}
            onClick={(e) =>
              handleUpdateAllSEFPageProgress(e, "Awaiting_Review")
            }
          >
            Awaiting Review
          </button>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <button
            style={{ width: "33%", backgroundColor: "#06862F" }}
            onClick={(e) => handleUpdateAllSEFPageProgress(e, "Complete")}
          >
            Complete
          </button>
          <button
            style={{ width: "33%", backgroundColor: "#06862F" }}
            onClick={(e) => handleUpdateAllSEFPageProgressEmail(e, "Complete")}
          >
            Complete + Email
          </button>
          <button
            style={{ width: "33%", backgroundColor: "purple" }}
            onClick={(e) => handleGoToNext(e)}
          >
            Next
          </button>
        </div>
      </div>
    </>
  );
}

export default SEFMassStage;
